<i *ngIf="icon" [class]="icon" [pTooltip]="toolTipMessage" tooltipPosition="right" style="font-size: 1.5em;"></i>